import { baseRestApi } from "api/rest/baseRestApi";

import { Carrier, PaymentPayer, PaymentTerms, Smc3Currency } from "./types";

type UrlParams = {
  scac: Carrier["scac"];
};

type Body = {
  credentials?: {
    username?: string;
    password?: string;
    securityCode?: string;
    key?: string;
    secret?: string;
    trackingSecret?: string;
  };
  contactId?: number;
  billingAddressId?: number;
  billingAccountNumber?: string;
  billingName?: string;
  paymentPayer?: PaymentPayer;
  paymentTerms?: PaymentTerms;
  paymentCurrency?: Smc3Currency;
};

type QueryArgs = {
  urlParams: UrlParams;
  body: Body;
};

type ResponseType = void;

module.hot?.accept();

export const upsertCarrierSmc3Api = baseRestApi.enhanceEndpoints({ addTagTypes: ["CARRIERS"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    upsertCarrierSmc3: builder.mutation<ResponseType, QueryArgs>({
      query: ({ urlParams, body }) => ({
        method: "POST",
        url: `shipper/smc3/carriers/${urlParams.scac}`,
        body,
      }),
      invalidatesTags: ["CARRIERS"],
    }),
  }),
});

export const { useUpsertCarrierSmc3Mutation } = upsertCarrierSmc3Api;
export type UpsertCarrierSmc3ResponseType = ResponseType;
